import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from '@kognitiv/bf-library';

const SearchBarButton = (props) => {
    const { onClick, isEnabled } = props;

    return (
        <div className="kbe-header-update-button-wrapper">
            <Button
                primary
                onClick={() => onClick()}
                className={`kbe-header-update-button search-bar-button-custom-class`}
                type="button"
                disabled={!isEnabled}
                content={<FormattedMessage id="bf.search" defaultMessage="bf.search" />}
            />
        </div>
    );
};

SearchBarButton.propTypes = {
    isEnabled : PropTypes.bool.isRequired,
    onClick   : PropTypes.func.isRequired,
};

export default SearchBarButton;
